import React, { useContext } from 'react';
import { MapWrapper, MapMarker, MapMarkerProps } from 'ui/components';
import { SiteContext } from 'application/adapters/context/SiteContext';
import logger from 'helpers/logger';

export interface MapProps {
	id: string;
	zoom?: number;
	apiKey?: string;
	mapMarkers: MapMarkerProps[];
	settings: {
		properties: {
			cluster?: boolean;
			width?: string;
			height: string;
		};
	};
}

export const Map: React.FC<MapProps> = ({
	apiKey,
	mapMarkers,
	id,
	zoom = 1,
	settings: {
		properties: { cluster = false, width, height },
	},
}) => {
	const siteContext = useContext(SiteContext);
	apiKey = apiKey ? apiKey : siteContext?.getSettings('mapsSettings')?.apiKey;
	if (!apiKey) {
		logger.error('Maps API key not set');
		apiKey = '';
	}

	const style = {
		height: height === undefined ? '100%' : height,
		width: width === undefined ? '100%' : width,
	};
	return (
		<>
			<MapWrapper apiKey={apiKey} id={id} cluster={cluster} zoom={zoom} style={style}>
				{mapMarkers.map((mapMarker) => {
					const {
						content: {
							properties: { title, text },
						},
					} = mapMarker;
					return (
						<MapMarker key={title} {...mapMarker}>
							<>
								<h1>{title}</h1>
								{text && <p dangerouslySetInnerHTML={{ __html: text }} />}
							</>
						</MapMarker>
					);
				})}
			</MapWrapper>
		</>
	);
};
